class CartRemoveButton extends HTMLElement {
  async setRelatedProducts() {
    async function fetchRelatedProducts(productId) {
      const response = await fetch(`/recommendations/products.json?product_id=${productId}&intent=related`);
      const data = await response.json();
      const relatedProducts = data.products;
      
      return relatedProducts.filter((product, index) => product.available && !product.tags.includes('brinde')).slice(0, 6);
    }
  
    const firstProduct = document.querySelector('.cart-items .cart-item:first-child');
    if (!firstProduct) {
      if (document.querySelector('.related_product_cart')) {
        document.querySelector('.related_products_cart').remove();
      }
      return;
    }
    
    const productId = firstProduct.getAttribute('data-product-id');
    const relatedProducts = await fetchRelatedProducts(productId);
    if (!relatedProducts.length) {
      if (document.querySelector('.related_product_cart')) {
        document.querySelector('.related_products_cart').remove();
      }
      return;
    }
    
    relatedProducts.map((product) => {
      const relatedProduct = document.createElement('div');
      relatedProduct.classList.add('related_product_cart__product');
      relatedProduct.innerHTML = `
        <div href="${product.url}" class="related_product_cart__product-link">
          <img src="${product.images[0]}" alt="${product.title}" class="related_product_cart__product-image">
          <div class="related_product_cart__product-info">
              <a href="${product.url}" class="related_product_cart__product-link-title related_product_cart__product-title">${product.title}</a>  
              <span class="related_product_cart__product-price">
                ${window.Shopify.currency.symbol}
                ${product.price / 100}</span>
              <div class="related_product_cart__product-info">
                <product-form data-section-id="template--22295391273261__product-grid"><form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
                    <button id="-submit" type="submit" name="add" class="quick-add__submit button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="-submit title-template--22295391273261__product-grid-${product.id}" aria-live="polite" data-sold-out-message="true">
                    <span>Adicionar</span>
                    <span class="sold-out-message hidden">Esgotado</span>
                    
                    
                    </button><input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--22295391273261__product-grid">
                </form></product-form>
              </div>
          </div>
        </div>
      `;
  
      let variants = product.variants.filter((variant) => variant.available);
      const selectVariant = document.createElement('select');
      selectVariant.name = 'id';
      selectVariant.classList.add('product-variant-id-select');
      selectVariant.setAttribute('aria-label', 'Selecione uma opção');
      selectVariant.setAttribute('data-variant-select', '');
      if (variants.length === 1) {
        selectVariant.style.display = 'none';
      }

      variants.map((variant) => {
        if (variant.available) {
          selectVariant.innerHTML += `<option value="${variant.id}">${variant.title}</option>`;
        }
      });

      const firstVariant = variants[0];
      relatedProduct.querySelector('.product-variant-id').value = firstVariant.id;

      relatedProduct.querySelector('.related_product_cart__product-price').insertAdjacentElement('afterend', selectVariant);
      document.querySelector('.related_products_cart__desktop .related_product_cart__products').appendChild(relatedProduct);
      const relatedProductMobile = relatedProduct.cloneNode(true);
      document.querySelector('.related_products_cart__mobile .related_product_cart__products').appendChild(relatedProductMobile);

      const selectVariantElement = relatedProduct.querySelector('[data-variant-select]');
      selectVariantElement.addEventListener('change', (event) => {
        const inputVariant = relatedProduct.querySelector('.product-variant-id');
        inputVariant.dispatchEvent(new Event('change'));
        inputVariant.setAttribute('value', event.target.value);
      });
    });
  }

  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);



window.setProgressBar = function(container, cart) {
  const progressBar = container.querySelector("#progress__freegift");
  const message = container.querySelector("#message__progressbar-freegift");
  const progressBarContainer = container.querySelector(".container__freegift-bar .freegift__progress-bar");
  const freeGiftValue = window.freeGift; 
  const currentAmount = cart.total_price / 100; 
  const totalNoDiscountCart = cart.original_total_price / 100;
  let maxTarget = 0
  if (freeGiftValue != null) {
    maxTarget = freeGiftValue
  } else {
    maxTarget = Math.max(150, 200, 250, freeGiftValue);
  }
  let currentProgress = Math.min(totalNoDiscountCart, maxTarget);
  let percentage = (currentProgress / maxTarget) * 100;

  progressBar.style.width = `${percentage}%`;

  let nextTarget = 250;
  let discountText = '';
  
  if (totalNoDiscountCart < 150) {
    nextTarget = 150;
    discountText = '10%OFF';
  } else if (totalNoDiscountCart < 200) {
    nextTarget = 200;
    discountText = '15%OFF';
  } else if (totalNoDiscountCart < 250) {
    nextTarget = 250;
    discountText = '20%OFF';
  } else {
    discountText = 'Desconto exclusivo';
    nextTarget = maxTarget;
  }

  let amountLeft = Math.max(nextTarget - totalNoDiscountCart, 0);

  const messageGift = document.querySelector("#message__is_giftbar_enabled");
  
  if (messageGift) {
    let giftAmountLeft = Math.max(freeGiftValue - totalNoDiscountCart, 0);
    if (giftAmountLeft > 0) {
      messageGift.innerHTML = `<span>Faltam <strong>R$ ${giftAmountLeft.toFixed(2).replace('.', ',')}</strong> para você ganhar um <strong>Presente Exclusivo!</strong></span>`;
    } else {
      messageGift.innerHTML = `<strong>Você ganhou um Presente Exclusivo!</strong>`;
    }
  }

  if (amountLeft > 0) {
    const messages = [];
    const amountLeft10 = Math.max(150 - totalNoDiscountCart, 0);
    const amountLeft15 = Math.max(200 - totalNoDiscountCart, 0);
    const amountLeft20 = Math.max(250 - totalNoDiscountCart, 0);
    
    if (amountLeft10 > 0) {
      messages.push(`<span>Faltam <strong>R$ ${amountLeft10.toFixed(2).replace('.', ',')}</strong> para você ganhar <strong>10%OFF</strong></span>`);
    }
    if (amountLeft15 > 0) {
      messages.push(`<span>Faltam <strong>R$ ${amountLeft15.toFixed(2).replace('.', ',')}</strong> para você ganhar <strong>15%OFF</strong></span>`);
    }
    if (amountLeft20 > 0) {
      messages.push(`<span>Faltam <strong>R$ ${amountLeft20.toFixed(2).replace('.', ',')}</strong> para você ganhar <strong>20%OFF</strong></span>`);
    }
    
    message.innerHTML = messages.join('');
  } else {
    message.innerHTML = `<strong>Parabéns! Você ganhou ${discountText}.</strong>`;
  }

  if (cart.total_price > 14999) {
    document.querySelector('.discount.d10').classList.add('active');
  } else {
    document.querySelector('.discount.d10').classList.remove('active');
  }

  if (cart.total_price > 19999) {
    document.querySelector('.discount.d15').classList.add('active');
  } else {
    document.querySelector('.discount.d15').classList.remove('active');
  }

  if (cart.total_price > 24999) {
    document.querySelector('.discount.d20').classList.add('active');
  } else {
    document.querySelector('.discount.d20').classList.remove('active');
  }
}

window.updateCart = () => {
    fetch(`${routes.root}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const items = html.querySelector('cart-drawer-items');
      document.querySelector('cart-drawer-items').innerHTML = items.innerHTML;
    })

    window.setRelatedProducts();
    discountCartApply();
    window.discountCodesFunction();
    window.showShippingCalculator();
    window.ShippingCalculator.init();
    window.checkCart();
}

function discountCartApply() {
  document.querySelectorAll('.discount_coupon .apply').forEach((button) => {
    button.addEventListener('click', () => {
      button.style.display = 'none';
      const nextElement = button.nextElementSibling;
      if (nextElement) {
        nextElement.style.display = 'block';
      }
    });
  });
}

window.updateGiftCheckout = function() {
  function addClickListener() {
    const buttons = document.querySelectorAll('.button-act-cart');
      
    if (buttons.length > 0) {
      clearInterval(interval);

      buttons.forEach(button => {
        button.addEventListener('click', function(event) {
              event.preventDefault();

              fetch('/cart.json')
                .then(response => response.json())
                .then(data => {
                  
                    let freeProductExists = data.items.some(item => item.properties && item.properties._free_product === 'true');
                    let subtotalExceedsLimit = data.items_subtotal_price > 29999;
          
                    if (subtotalExceedsLimit) {
                        if(freeProductExists){
                          window.location.href = "/checkout";
                        }else{
                            //alert('Você ganhou um brinde, escolha uma opção para continuar sua compra.');
                            console.log('Você ganhou um brinde, escolha uma opção para continuar sua compra.');
                        }
                    }else{
                        window.location.href = "/checkout";
                    }
                  })
                  .catch(error => console.error('Erro ao obter dados do carrinho:', error));

              return false;
          });
        });
      }
  }

  const interval = setInterval(addClickListener, 2000);
}


window.updateFreeGiftProgressBar = function() {
  fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {          
          document.querySelectorAll('.container__freegift-bar').forEach(container => {
              window.setProgressBar(container, cart);
          });
      })
      .catch(error => {
          console.error('Erro:', error);
      });
}

window.addEventListener('DOMContentLoaded', () => {
  updateProgressBar();
  //window.updateGiftCheckout();
  window.updateFreeGiftProgressBar();
  discountCartApply();
  window.ShippingCalculator.init();
});

window.setRelatedProducts = async function setRelatedProducts() {
    async function fetchRelatedProducts(productId) {
      const response = await fetch(`/recommendations/products.json?product_id=${productId}&intent=related`);
      const data = await response.json();
      const relatedProducts = data.products;
      
      return relatedProducts.filter((product, index) => product.available && !product.tags.includes('brinde')).slice(0, 6);
    }
  
    const firstProduct = document.querySelector('.cart-items .cart-item:first-child');
    if (!firstProduct) {
      if (document.querySelector('.related_product_cart')) {
        document.querySelector('.related_products_cart').remove();
      }
      return;
    }
    
    const productId = firstProduct.getAttribute('data-product-id');
    const relatedProducts = await fetchRelatedProducts(productId);
    if (!relatedProducts.length) {
      if (document.querySelector('.related_product_cart')) {
        document.querySelector('.related_products_cart').remove();
      }
      return;
    }
    
    relatedProducts.map((product) => {
      const relatedProduct = document.createElement('div');
      relatedProduct.classList.add('related_product_cart__product');
      relatedProduct.innerHTML = `
        <div href="${product.url}" class="related_product_cart__product-link">
          <img src="${product.images[0]}" alt="${product.title}" class="related_product_cart__product-image">
          <div class="related_product_cart__product-info">
              <a href="${product.url}" class="related_product_cart__product-link-title related_product_cart__product-title">${product.title}</a>  
              <span class="related_product_cart__product-price">
                ${window.Shopify.currency.symbol}
                ${product.price / 100}</span>
              <div class="related_product_cart__product-info">
                <product-form data-section-id="template--22295391273261__product-grid"><form method="post" action="/cart/add" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id" value="${product.variants[0].id}" class="product-variant-id">
                    <button id="-submit" type="submit" name="add" class="quick-add__submit button--full-width button--secondary" aria-haspopup="dialog" aria-labelledby="-submit title-template--22295391273261__product-grid-${product.id}" aria-live="polite" data-sold-out-message="true">
                    <span>Adicionar</span>
                    <span class="sold-out-message hidden">Esgotado</span>
                    
                    
                    </button><input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" value="template--22295391273261__product-grid">
                </form></product-form>
              </div>
          </div>
        </div>
      `;
  
      let variants = product.variants.filter((variant) => variant.available);
      const selectVariant = document.createElement('select');
      selectVariant.name = 'id';
      selectVariant.classList.add('product-variant-id-select');
      selectVariant.setAttribute('aria-label', 'Selecione uma opção');
      selectVariant.setAttribute('data-variant-select', '');
      if (variants.length === 1) {
        selectVariant.style.display = 'none';
      }

      variants.map((variant) => {
        if (variant.available) {
          selectVariant.innerHTML += `<option value="${variant.id}">${variant.title}</option>`;
        }
      });

      const firstVariant = variants[0];
      relatedProduct.querySelector('.product-variant-id').value = firstVariant.id;

      relatedProduct.querySelector('.related_product_cart__product-price').insertAdjacentElement('afterend', selectVariant);
      document.querySelector('.related_products_cart__desktop .related_product_cart__products').appendChild(relatedProduct);
      const relatedProductMobile = relatedProduct.cloneNode(true);
      document.querySelector('.related_products_cart__mobile .related_product_cart__products').appendChild(relatedProductMobile);

      const selectVariantElement = relatedProduct.querySelector('[data-variant-select]');
      selectVariantElement.addEventListener('change', (event) => {
        const inputVariant = relatedProduct.querySelector('.product-variant-id');
        inputVariant.dispatchEvent(new Event('change'));
        inputVariant.setAttribute('value', event.target.value);
      });
    });
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    window.addEventListener('cart:updated', () => {
      this.onCartUpdate();
    });

    window.onCartUpdate = () => {
      this.onCartUpdate();
    };
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    //Atualiza o carrinho
    updateProgressBar();
    //window.updateGiftCheckout();
    window.updateFreeGiftProgressBar()
    discountCartApply();
    window.discountCodesFunction();
    window.showShippingCalculator();
    window.ShippingCalculator.init();
    window.checkCart();
    window.setRelatedProducts();
    document.dispatchEvent(new Event('cart:updated'));
    
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          discountCartApply();
          window.discountCodesFunction();
          window.showShippingCalculator();
          window.ShippingCalculator.init();
          window.checkCart();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          document.querySelector('cart-items').innerHTML = sourceQty.innerHTML;
          discountCartApply();
          window.discountCodesFunction();
          window.showShippingCalculator();
          window.ShippingCalculator.init();
          window.checkCart();
          window.setRelatedProducts();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    // Atualiza a quantidade do carrinho
    // this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        updateProgressBar();
        //window.updateGiftCheckout();
        window.updateFreeGiftProgressBar()
        discountCartApply();
        window.showShippingCalculator();
        window.checkCart();
        window.setRelatedProducts();
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
        if (parsedState.item_count === 0) {
          // location.reload();
          if (document.querySelector('.page_cart > div')) document.querySelector('.page_cart > div').classList.add('width-100');
          // document.querySelector('.related-products').style.display = 'none';
        }

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        document.dispatchEvent(new Event('cart:updated'));
      })
      .catch((e) => {
        // this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // this.disableLoading(line);
        // checkCartItem();
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

if (!customElements.get('cart-gift-card')) {
  customElements.define(
    'cart-gift-card',
    class CartGiftCard extends HTMLElement {
      constructor() {
        super();
        this.loadSavedValues();

        this.addEventListener(
          'input',
          debounce(() => {
            this.saveValues();
            this.toggleContainerVisibility();
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }

      async loadSavedValues() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();
          const attributes = cart.attributes || {};

          this.querySelector('[name="Cartão de presente (De)"]').value = attributes["Cartão de presente (De)"] || '';
          this.querySelector('[name="Cartão de presente (Para)"]').value = attributes["Cartão de presente (Para)"] || '';
          this.querySelector('[name="Cartão de presente (Mensagem)"]').value = attributes["Cartão de presente (Mensagem)"] || '';

          this.toggleContainerVisibility();
        } catch (error) {
          console.error("Erro ao carregar atributos do carrinho:", error);
        }
      }

      saveValues() {
        const remetente = this.querySelector('[name="Cartão de presente (De)"]').value;
        const destinatario = this.querySelector('[name="Cartão de presente (Para)"]').value;
        const mensagem = this.querySelector('[name="Cartão de presente (Mensagem)"]').value;

        const body = JSON.stringify({
          attributes: {
            "Cartão de presente (De)": remetente,
            "Cartão de presente (Para)": destinatario,
            "Cartão de presente (Mensagem)": mensagem
          }
        });

        fetch(`${routes.cart_update_url}`, { 
          ...fetchConfig(), 
          ...{ body }
        });
      }

      toggleContainerVisibility() {
        const container = this.querySelector('.gift-message-container-inputs');
        const remetente = this.querySelector('[name="Cartão de presente (De)"]').value.trim();
        const destinatario = this.querySelector('[name="Cartão de presente (Para)"]').value.trim();
        const mensagem = this.querySelector('[name="Cartão de presente (Mensagem)"]').value.trim();

        if (remetente || destinatario || mensagem) {
          container.classList.remove('hidden');
        } else {
          container.classList.add('hidden');
        }
      }
    }
  );
}


function isHaomaExperiencePage() {
  return window.location.href.includes('haoma-experience');
}

function isProductPage() {
  return window.location.href.includes('products');
}

async function cleanCartDrawer() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

async function removeCoupons() {
  try {
    const response = await fetch('/discount/remove', {
      method: 'GET',
    });
    const data = await response.text();
    return data;
  } catch (error) {
    console.error('Erro na remoção de cupom:', error);
    throw error;
  }
}

async function removeCouponsProducts() {
  try {
    await Promise.all([removeCoupons(), cleanCartDrawer()]);
  } catch (error) {
    console.error('Erro ao remover cupons e limpar carrinho:', error);
  }
}

async function main() {
  try {
    if (window.location.href.includes('/products/haoma-experience')) {
        if (innerWidth > 768) {
          document.querySelector('.announcement-bar > div p').innerHTML = 'Experimente os Bests Sellers da Haoma com FRETE GRÁTIS.';
        }else{
          setTimeout(() => {
            document.querySelector(".announcement-bar").innerHTML = `
            <div class="announcement-bar" role="region" aria-label="Comunicado">
            <p class="announcement-bar__message h5" style="display: block;">
            EXPERIMENTE OS BESTS SELLERS DA HAOMA COM FRETE GRÁTIS.
            </p>
            <p></p></div>`;
          }, 1800);
        }
    }
    
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const brinde = cart.items.find(item => item.handle === 'haoma-experience');
   
    if (isProductPage()) {
      if (brinde || isHaomaExperiencePage()) {
        document.querySelector('.announcement-bar > div > p').style = 'text-transform: uppercase;';
        document.querySelector('.header-wrapper').style.display = 'none';
        document.querySelector('.footer_news').style.display = 'none';
        document.querySelector('.footer__content-top').style.display = 'none';
        document.querySelector('.footer__cards .parcel').style.display = 'none';
        document.querySelector(".sample-product-page__container .button").style.display = "block"; 
        await removeCouponsProducts();
      }
    } 
    if (brinde && window.location.href != '/products/haoma-experience') {
      removeHaomaExperienceProduct();
      setTimeout(() => {
        location.reload();
      }, 1500);
    }
  } catch (error) {
    console.error('Erro ao processar:', error);
  }
}

function removeHaomaExperienceProduct() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      debugger;
      const haomaExperienceItem = cart.items.find(item => item.handle === 'haoma-experience');
      
      if (haomaExperienceItem) {
        console.log(haomaExperienceItem);
        const variantId = haomaExperienceItem.variant_id.toString();

        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(data => console.log('Product removed', data));
      }
    });
}

main();




// function isHaomaExperiencePage() {
//   return window.location.href.includes('haoma-experience');
// }

// function isProductPage() {
//   return window.location.href.includes('products');
// }

// fetch('/cart.js')
//   .then(response => response.json())
//   .then(cart => {
//     // console.log(cart);
//     const brinde = cart.items.find(item => item.handle === 'haoma-experience');
   
//     if(isProductPage()){
//       if (brinde || isHaomaExperiencePage()) {
//         document.querySelector('.announcement-bar > div > p').innerHTML = 'Experimente os Bests Sellers da Haoma com FRETE GRÁTIS.';
//         document.querySelector('.announcement-bar > div > p').style = 'text-transform: uppercase;';
//         document.querySelector('.header-wrapper').style.display = 'none';
//         document.querySelector('.footer_news').style.display = 'none';
//         document.querySelector('.footer__content-top').style.display = 'none';
//         document.querySelector('.footer__cards .parcel').style.display =  'none';
//         document.querySelector(".sample-product-page__container .button").style.display = "block"; 
//         cleanCartDrawer()
//         removeCoupons();
//       }
//     }else{
//       document.getElementById('cart-icon-bubble').style.display = 'none';
//       document.querySelector('.header__icon-haoma-sample').style.display = 'flex';
//     }

//     if(brinde && window.location.href != '/products/haoma-experience'){
//       removeCouponsProducts();
//       cleanCartDrawer()
//     }

//   })
//   .catch(error => {
//     console.error('Erro ao buscar o carrinho:', error);
//   });

// function cleanCartDrawer() {
//   fetch('/cart/clear.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     }
//   })
//     .then(response => response.json())
//     .then(data => {
//       console.log('Carrinho limpo com sucesso:', data);
//     })
//     .catch(error => {
//       console.error('Erro ao limpar o carrinho:', error);
//     });
// }

// function removeCoupons() {
//   fetch('/discount/remove', {
//     method: 'GET',
//   })
//   .then(response => response.json())
//   .then(data => console.log('Requisição bem-sucedida:', data))
//   .catch(error => console.error('Erro na requisição:', error));
// }

// function removeCouponsProducts(){
//   //remove all products and coupons from cart
//   fetch('/discount/remove', {
//     method: 'GET'
//   })
//   .then(response => response.text())
//   .then(data => console.log('Cupom removido com sucesso:'))
//   .catch(error => console.error('Erro na remoção de cupom:', error));
  
//   fetch('/cart/clear', {
//     method: 'GET'
//   })
//   .then(response => response.text())
//   .then(data => console.log('Carrinho limpo com sucesso:'))
//   .catch(error => console.error('Erro ao limpar o carrinho:', error));

// }


